import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const FETCH_USER_PROGRAM_ORDERS_API = 'EMPLOYEE/FETCH_USER_PROGRAM_ORDERS_API'

const apiCall = enhancedMakeFetchAction(
  FETCH_USER_PROGRAM_ORDERS_API,
  ({ programId, id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/user-programs/${programId}/program-orders/${id}`,
      params
    }),
    method: 'GET'
  })
)

export default apiCall
